<template>
	<GBRightPane
		v-bind:display="display"
		v-on:close="onClose"
	>
		<GBModalVScrollable class="add-member-list"
			title="メンバー追加"
			header_height="115"
			bottom_height="0"
			v-on:close="onClose"
		>
			<template v-slot:header>
				<v-layout row class="modal-header-filter">
					<v-flex xs10 class="mx-2">
						<v-text-field dark clearable height="23" v-model="filter_name" placeholder="名前で検索" color="white" single-line></v-text-field>
					</v-flex>
					<v-flex xs2 class="mx-2">
						<v-btn v-if="isFiltering" dark icon color="orange" v-on:click="onClickFiltering"><v-icon>filter_list</v-icon></v-btn>
						<v-btn v-else flat icon blue color="white" v-on:click="onClickFiltering"><v-icon>filter_list</v-icon></v-btn>
					</v-flex>
				</v-layout>
			</template>
			<template v-if="display">
				<GBSelectMemberListRow
					v-for="item in filteredMemberList"
					v-bind:key="item.member.code"
					v-bind:item="item.member"
					v-bind:alert="item.alert"
					v-bind:selectedMember="selectedMember"
					v-on:change-select-member="changeSelectMember"
					ref="member"
				/>
			</template>
		</GBModalVScrollable>
	</GBRightPane>
</template>
<script>
import GBRightPane from './GBRightPane';
import GBModalVScrollable from './GBModalVScrollable';
import GBSelectMemberListRow from './GBSelectMemberListRow';
import Notification from '../classes/Notification';
import Util from '../classes/Util';

export default {
	name: 'GBRightPaneAddMember',
	props: [
		"value",
		"members",
	],
	components: {
		GBRightPane,
		GBModalVScrollable,
		GBSelectMemberListRow,
	},
	data: function() {
		return {
			filter_name: '',
		};
	},
	methods: {
		onClose: function() {
			this.filter_name = '';
			this.$emit('close');
		},
		changeSelectMember: function(e) {
			if (e.select) {
				this.$store.dispatch('addMemberToProject', {
					member_code: e.item.code,
					project_code: this.value.code,
				}).then((res) => {
					if (res) {
						this.$emit('update-dataset');
					} else {
						this.$store.commit('addNotification', Notification.error('更新対象が削除されています', 'notificationCreateData'));
						this.onClose();
					}
				});
			} else {
				this.$store.dispatch('deleteMemberFromProject', {
					member_code: e.item.code,
					project_code: this.value.code,
				}).then((res) => {
					if (res) {
						this.$emit('update-dataset');
					} else {
						this.$store.commit('addNotification', Notification.error('更新対象が削除されています', 'notificationCreateData'));
						this.onClose();
					}
				});
			}
		},
		onClickFiltering: function() {
			this.$emit('show-member-filtering', true);
		},
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		filteredMemberList: function() {
			if (this.members == null)
				return;
			let ret = this.$store.getters.filteredMemberList(this.members, this.selectedMember);
			return ret.filter((item) => {
				if (this.filter_name === null)
					return true;
				if (this.filter_name.length === 0)
					return true;
				return item.member.name.search(Util.replaceEscapeString(this.filter_name)) >= 0;
			});
		},
		isFiltering: function() {
			return this.$store.getters.isFilteringMemberList;
		},
		selectedMember: function() {
			if (!this.value)
				return;
			let project = this.$store.getters.projectList.filter( p => { return p.code === this.value.code })[0];
			if (!project)
				return;
			return project.children;
		},
	},
}
</script>
<style>
	.modal-window.add-member-list .row-group {
		position: relative;
		flex: 1 1 auto;
		width: 100%;
		height: 84px;
		background-color: #fefefe;
		border-bottom: solid 1px #a9a9a9;
	}
	.modal-window.add-member-list .row {
		width: 290px;
	}
	.modal-window.add-member-list .name {
		font-size: 18px;
	}
	.modal-window.add-member-list .tel {
		font-size: 14px;
	}
	.modal-window.add-member-list .modal-header-filter {
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>
